import { useTranslation } from '@/hooks/useTranslation';
import { COOKIE_POLICY_URL, PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from '@/lib/legal';
import { linkHitAreaClasses } from '@/lib/shared-variants';
import { cn } from '@/lib/utils';

/** The legal links at the foot of the signup and sign-in screens. */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation();
  const links = [
    { href: TERMS_AND_CONDITIONS_URL, label: t('Terms and Conditions') },
    { href: PRIVACY_POLICY_URL, label: t('Privacy Policy') },
    { href: COOKIE_POLICY_URL, label: t('Cookie Policy') },
  ];

  return (
    <nav aria-label={t('Legal')}>
      <ul className={cn('flex flex-wrap gap-xxl text-size-n2 leading-[18px]', className)}>
        {links.map(({ href, label }) => (
          <li key={href}>
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className={cn('hover:underline', linkHitAreaClasses)}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
